class SessionManager {
  constructor() {
    this.API_URL = import.meta.env.VITE_API_URL;
    this.activeSessions = new Map(); // Track sessions by bookId
  }

  // Register a new active session
  registerSession(bookId, sessionId, startTime) {
    this.activeSessions.set(bookId, {
      id: sessionId,
      startTime,
      isEnding: false,
    });
  }

  // Check if there's an active session for the book
  hasActiveSession(bookId) {
    return this.activeSessions.has(bookId);
  }

  // End session with synchronous XHR to ensure completion
  endSession(bookId) {
    const session = this.activeSessions.get(bookId);
    if (!session || session.isEnding) return false;

    session.isEnding = true;
    
    // DEVELOPMENT MODE: Skip API call entirely to avoid 404 errors
    // We're just cleaning up the session locally for now
    // TODO: Once backend is updated, restore the API call
    
    // Clean up locally - this is all we really need during development
    this.activeSessions.delete(bookId);
    console.log("Session ended locally (API call skipped)");
    return true;
  }

  // Clean up all active sessions
  endAllSessions() {
    for (const [bookId] of this.activeSessions) {
      this.endSession(bookId);
    }
  }
}

export const sessionManager = new SessionManager();

// Clean up sessions on window unload
window.addEventListener("beforeunload", () => {
  sessionManager.endAllSessions();
});

